import { render, staticRenderFns } from "./MsgElementSessionAskPatient.vue?vue&type=template&id=73d13d9e&scoped=true"
import script from "./MsgElementSessionAskPatient.vue?vue&type=script&lang=js"
export * from "./MsgElementSessionAskPatient.vue?vue&type=script&lang=js"
import style0 from "./MsgElementSessionAskPatient.vue?vue&type=style&index=0&id=73d13d9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d13d9e",
  null
  
)

export default component.exports